import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

function AddToHomeScreenPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [open, setOpen] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Detect iOS device (since iOS doesn't support beforeinstallprompt)
    const userAgent = window.navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    setIsIOS(iOS);

    if (!iOS) {
      // Listen for the beforeinstallprompt event
      const handler = (e) => {
        console.log("beforeinstallprompt Event fired");
        e.preventDefault(); // Prevent automatic prompt

        // Store the event for later
        setDeferredPrompt(e);
        setOpen(true); // Show the install prompt dialog
      };

      window.addEventListener("beforeinstallprompt", handler);
      return () => window.removeEventListener("beforeinstallprompt", handler);
    } else {
      // iOS devices need manual install instructions
      setOpen(true);
    }
  }, []);

  const handleAddToHomeScreen = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;

      console.log(`User response: ${outcome}`);
      if (outcome === "dismissed") {
        console.log("User cancelled home screen install");
      } else {
        console.log("User added to home screen");
      }

      // Reset deferredPrompt after use
      setDeferredPrompt(null);
      setOpen(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        style: { backgroundColor: "rgba(40,29,68)" },
      }}
    >
      <DialogTitle
        style={{ color: "#ff6f61", display: "flex", alignItems: "center" }}
      >
        Add to Home Screen
      </DialogTitle>
      <DialogContent>
        {isIOS ? (
          <Typography style={{ color: "#ff6f61" }}>
            To install this app on your iOS device, tap the Share button in
            Safari and then select "Add to Home Screen."
          </Typography>
        ) : (
          <Typography style={{ color: "#ff6f61" }}>
            For a better experience, add this app to your home screen.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} style={{ color: "#ff6f61" }}>
          Maybe Later
        </Button>
        {!isIOS && deferredPrompt && (
          <Button onClick={handleAddToHomeScreen} style={{ color: "#ff6f61" }}>
            Add Now
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default AddToHomeScreenPrompt;
